// extracted by mini-css-extract-plugin
export default {"moreButton":"xYl9vr","icon":"ohr91b"};